import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {useFavorites} from "components/hooks/useFavorites.js";

const FavoriteButton = ({contentHash, type, hideIfUnfavorited=false}) => { 
    const {toggleFavorite, isFavorited} = useFavorites({
        contentHash: contentHash,
        type
    });

    if (hideIfUnfavorited && !isFavorited || !contentHash) {
        return [];
    }

    return (
        <div
          onClick={(e) => {
              e.stopPropagation();
              toggleFavorite(e);
          }}
          className={isFavorited ? "favorite-button heart favorited" : "favorite-button heart"}/>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteButton);
